import React from 'react'

import '../../../styles/css/loader-animated.css'

function LoaderAnimated(props) {
  const { animated, maxWidth, height } = props
  const style = {}
  
  if (maxWidth) {
    style.maxWidth = maxWidth
  }
  
  if (height) {
    style.height = height
  }

  return (
    <div className={`loader ${animated ? 'animate' : ''}`} style={style} />
  );
}

export default LoaderAnimated;